import { render, staticRenderFns } from "./CourseOrderListByCourse.vue?vue&type=template&id=8b7c836c&scoped=true"
import script from "./CourseOrderListByCourse.vue?vue&type=script&lang=js"
export * from "./CourseOrderListByCourse.vue?vue&type=script&lang=js"
import style0 from "./CourseOrderListByCourse.vue?vue&type=style&index=0&id=8b7c836c&prod&scoped=true&lang=css"
import style1 from "./CourseOrderListByCourse.vue?vue&type=style&index=1&id=8b7c836c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c836c",
  null
  
)

export default component.exports